export default {
  'TopItems.title': 'Top items',
  'TopItems.products': 'Products',
  'TopItems.avgRating': 'Avg rating',
  'TopItems.sentiment': 'Sentiment',
  'TopItems.best': 'Best',
  'TopItems.worst': 'Worst',
}
